import React, { useState } from "react";
import { Grid, TextField, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import YouSign from "../../Generics/Yousign";

const Step_7_Delegation = ({
  delegation,
  formDataYousign,
  setFormDataYousign,
  errors,
  activeProcessYousign,
  signatureLink,
  endSignatureProcess,
}) => {
  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Firma elettronica della delega
        </Typography>
        <Typography className="text-steps" style={{ marginTop: "10px" }}>
          Scorri il documento fino in fondo e{" "}
          <span style={{ fontWeight: "bold" }}>segui le istruzioni</span> nel
          riquadro per apporre la tua firma elettronica.
        </Typography>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              overflow: "hidden",
              border: "1px solid #ccc",
              marginBottom: "100px",
              position: "relative",
            }}
          >
            <YouSign
              endSignatureProcess={endSignatureProcess}
              signatureLink={signatureLink}
              delegation={delegation}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_7_Delegation;
